<template>
  <tr :class="{'clickable': $can('edit', 'YachtManufacturer')}">
    <td>
      {{ yachtManufacturer.name }}
    </td>
    <td>
      {{ yachtManufacturer.country.name }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'YachtManufacturerRow',
    props: {
      yachtManufacturer: {
        type: Object,
        default: null
      }
    }
  }
</script>
